import { ADMSRDF } from '../const/C';
import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import {ContentEMDRequest} from '../virtuoso/request';
import Lsettings from '../liferay/settings';
import LApiUtils from '../liferay/ApiUtils';

//Загрузка содержимого каталога моделей, содержащийх ЕМД  (из модуля adms)
//Загружается список asset по условию и дополнительному условию, что родительским элементом должен быть NodId 
//Заданный в repository
export const EMDActions = {
    LOAD_LIST_STARTED: () => ({
        type: "EMDActions.LOAD_LIST_STARTED"
    }),
    LOAD_LIST_OK: members => ({
        type: "EMDActions.LOAD_LIST_OK",
        members,
    }),
    LOAD_LIST_ERROR: () => ({
        type: "EMDActions.LOAD_LIST_ERROR"
    }),

    //Загрузка списка элементов
    // repository - указывает каталог (NodId) в котором записаны элементы
    // offset, limit - начало и колчество записей для загрузки ( на данном этапе игнорируется) 
    // filter - дополнительные условия отбора (для связи между каталогом и дополнительным фильтром используется логическое И)
    loadMembers: (repository, offset, limit, filter) => dispatch => {
        dispatch(EMDActions.LOAD_LIST_STARTED());
        const condition = 'ParId='+repository + ((filter)? " and "+filter:"");
        return executeGetAssets({host:csiHost, module:"adms", condition, type: "adms_asset"}) 
            .then(response => { 
                //console.log("loadMembers", response);
                const members = (response.assets)? response.assets.data: [];
                const tags = (response.tags)? response.tags.data: [];
                dispatch(EMDActions.LOAD_LIST_OK({members, offset, limit, repository, tags}));
                return response;
            })
            .catch(e => { 
                console.error(new Error("cannot load descriptions module adms",e)); 
                dispatch(EMDActions.LOAD_LIST_ERROR());
                return Promise.reject(e);
            });
    },

    LOAD_ITEM_STARTED: () => ({
        type: "EMDActions.LOAD_ITEM_STARTED",
    }),
    LOAD_ITEM_OK: selected => ({
        type: "EMDActions.LOAD_ITEM_OK",
        selected,
    }),
    LOAD_ITEM_ERROR: () => ({
        type: "EMDActions.LOAD_ITEM_ERROR",
    }),

    //Загружает информацию по одному элементу каталога
    loadSelected: (NodId, repository)  => dispatch => {
        dispatch(EMDActions.LOAD_ITEM_STARTED());
        return executeGetAsset({host:csiHost, module:"adms", id: NodId, type: "adms_asset"}) 
            .then(response => { 
                //console.log("executeGetAsset", response);
                dispatch(EMDActions.LOAD_ITEM_OK({record: response.asset, id:NodId}));
                return response;
            })
            .catch(e => { 
                console.error(new Error("cannot load selected in module adms",e)); 
                dispatch(EMDActions.LOAD_ITEM_ERROR());
                return Promise.reject(e);
            });
    },

    CHANGE_CONDITIONS: conditions => ({
        type: "EMDActions.CHANGE_CONDITIONS",
        conditions,
    }),

    changeConditions: conditions => dispatch => {
        dispatch(EMDActions.CHANGE_CONDITIONS(conditions));
        return Promise.resolve(conditions);
    },

//История ЕМД    
    LOAD_HISTORY_STARTED: () => ({
        type: "EMDActions.LOAD_HISTORY_STARTED"
    }),
    LOAD_HISTORY_OK: members => ({
        type: "EMDActions.LOAD_HISTORY_OK",
        members,
    }),
    LOAD_HISTORY_ERROR: () => ({
        type: "EMDActions.LOAD_HISTORY_ERROR"
    }),

    //Загрузка списка элементов, входящих в историю
    // repository - указывает каталог (NodId) в котором записаны элементы
    // offset, limit - начало и колчество записей для загрузки ( на данном этапе игнорируется) 
    loadHistory: (repository, offset, limit) => dispatch => {
        dispatch(EMDActions.LOAD_HISTORY_STARTED());
//        const condition = 'ParId='+repository + ((filter)? " and "+filter:"");
        const condition = 'ParId='+repository;
        return executeGetEMDHistory({host:csiHost, module:"adms", condition, type: "adms_asset"}) 
            .then(response => { 
                console.log("executeGetEMDHistory", response);
                const members = (response.assets)? response.assets.data: [];
                dispatch(EMDActions.LOAD_HISTORY_OK({members, offset, limit, repository}));
                return response;
            })
            .catch(e => { 
                console.error(new Error("cannot load descriptions module adms",e)); 
                dispatch(EMDActions.LOAD_HISTORY_ERROR());
                return Promise.reject(e);
            });
    },

//Содержимое ЕМД    
LOAD_CONTENT_STARTED: () => ({
    type: "EMDActions.LOAD_CONTENT_STARTED"
}),
LOAD_CONTENT_OK: content => ({
    type: "EMDActions.LOAD_CONTENT_OK",
    content,
}),
LOAD_CONTENT_ERROR: () => ({
    type: "EMDActions.LOAD_CONTENT_ERROR",
}),

//Загрузка содержимого ЕМД
// graph - граф, в котором содержится ЕМД
// endpoint - указывает точку, в которой содержится граф с ЕМД
	loadContent: (graph, endpoint) => dispatch => {
  	dispatch(EMDActions.LOAD_CONTENT_STARTED());
    const options = {...settings.options};
    ContentEMDRequest.setGraph(graph);
    return ApiUtils.query(ContentEMDRequest, {}, options)
        .then(response => { 
            //console.log("EMDActions.js loadContent", response);
            //const {head, results} = response;
            //const {distinct, ordered, bindings} = results;
            dispatch(EMDActions.LOAD_CONTENT_OK(response));
            return response;
        })
        .catch(e => { 
            console.error(new Error("cannot load content EMD graph",e)); 
            dispatch(EMDActions.LOAD_CONTENT_ERROR());
            return Promise.reject(e);
        });
	},
	
  //Загрузка содержимого ЕМД из URL
  // url - url c модержимым триплетов
  loadContentByURL: (url) => dispatch => {
    dispatch(EMDActions.LOAD_CONTENT_STARTED());
    const options = {
      method: 'GET',
      headers: {'Content-Type': 'application/json','Accept': 'application/json',},
      credentials: 'include',
      mode: 'cors',
    }
    return fetch(url, options)
      .then(response => {
        return response.json()
      })
      .then(function (response) {
        //console.log("EMDActions.js fetch(url, options)", url, options, response);
        dispatch(EMDActions.LOAD_CONTENT_OK(response));
        return response;
      })
      .catch(e => {
        dispatch(EMDActions.LOAD_CONTENT_ERROR());
        return Promise.reject(e);
      });
  },

  PLANTUML_STARTED: () => ({
		type: "EMDActions.PLANTUML_STARTED"
	}),
	PLANTUML_OK: (script, url) => ({
		type: "EMDActions.PLANTUML_OK",
		script, url,
	}),
	PLANTUML_ERROR: (error) => ({
		type: "EMDActions.PLANTUML_ERROR",
		error
	}),

	getPluntumlURL: (script) => dispatch => {
		dispatch(EMDActions.PLANTUML_STARTED());		
    const options = {...Lsettings.options};
    const formData = {
      'cmd': JSON.stringify({'/emd.emd/get-uml':{}}),
      'script': script
    }
    return LApiUtils.postToLifeRay721(formData, options)
      .then ((response) =>{
        console.log("Done!", response);
        //const { count, items, years} = response;
        dispatch(EMDActions.PLANTUML_OK(script, response));
        return Promise.resolve(response);
      })
      .catch(e => { 
				console.error(new Error("cannot make plauntuml url ",e)); 
        dispatch(EMDActions.PLANTUML_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
	},
}